module.exports = __webpack_public_path__ + "img/wave-3.ea2c5568.svg";